<template>
  <div class="homeView_wrapper">
    <!-- 产品中心 -->
    <div class="product_wrap">
      <!-- 标题 -->
      <div class="item_title">
        <div class="item_title_top">产品中心</div>
        <div class="item_title_btm">PRODUCTS</div>
      </div>
      <!-- list -->
      <div class="product_list_top">
        <div class="top_item">
          <img src="../assets/home/top_icon_1.png" alt="" />
          <span>无人值守危废库</span>
        </div>
        <div class="top_item">
          <img src="../assets/home/top_icon_2.png" alt="" />
          <span>危废终端设备</span>
        </div>
        <div class="top_item">
          <img src="../assets/home/top_icon_3.png" alt="" />
          <span>精细化管理</span>
        </div>
        <div class="top_item">
          <img src="../assets/home/top_icon_4.png" alt="" />
          <span>危废收集数字化管理系统</span>
        </div>
        <div class="top_item">
          <img src="../assets/home/top_icon_5.png" alt="" />
          <span>固体废物全过程智慧化管理平台</span>
        </div>
      </div>
      <!-- line -->
      <div class="product_line">
        <div class="line"></div>
      </div>
      <!-- 无人值守危废库 -->
      <div class="priduct_nobody">
        <div class="nobody_bg">
          <div class="nobody_cont">
            <div class="cont_top">无人值守危废暂存库</div>
            <div class="cont_mid">一体式数字化智能仓储</div>
            <div class="cont_more" @click="routerPages('/unattended')">
              定制了解更多
              <img src="../assets/home/red_right.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 危废终端设备 -->
      <!-- 精细化管理 -->
      <!-- 危废收集数字化管理系统 -->
      <!-- 固体废物全过程智慧化管理平台  组件-->
      <div
        style="width: 100%; padding: 0 167px; box-sizing: border-box"
        class="priduct_2"
      >
        <carouselCom></carouselCom>
      </div>
      <div
        class="priduct_3"
        style="padding: 5px 12px; box-sizing: border-box; width: 100%"
      >
        <el-carousel :interval="5000" arrow="always" height="370px">
          <el-carousel-item
            v-for="(item, index) in listData"
            :key="index"
            class="carouselCom_cont_item"
          >
            <div>
              <div class="carouselCom_cont_top">{{ item.contTop }}</div>
              <div class="carouselCom_cont_mid">{{ item.contMid }}</div>
              <div class="carouselCom_cont_more" @click="routerPagess(index)">
                了解更多<img src="../assets/home/red_right.png" alt="" />
              </div>
            </div>
            <div class="carouselCom_cont_img">
              <img :style="{ height: item.height }" :src="item.imgUrl" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="about_wrap">
      <div class="item_title">
        <div class="item_title_top">关于我们</div>
      </div>
      <div class="about_text">
        越华诚数字科技(山东)有限公司隶属于天大越华子公司，越华诚致力于环保信息化、数字化、智能化的研发，主要为产废单位、经营单位、监管单位客户提供软件系统及智慧终端设备。自企业成立伊始，越华就确立了“专业专注、诚信服务”的企业发展思想，并且凭借优异的产品质量，先后于天津大学、山东大学、济南大学、山东工程技师学院齐鲁理工学院等数十所知名高校建立了良好的战略发展及合作关系，致力于通过信息技术的创新为环保事业添砖加瓦，成为受社会、客户、股东和员工尊敬的公司。
      </div>
      <div
        class="about_more"
        @click="routerPages('/about')"
        style="font-size: 10px"
      >
        了解更多<img src="../assets/home/red_right.png" alt="" />
      </div>
      <div class="about_top_max">
        <img src="../assets/home/about_max.png" alt="" />
      </div>
      <div class="about_btm_min">
        <!-- 荣誉资质证书 -->
        <div class="about_btm_min_item">
          <div class="min_item_top">荣誉资质证书</div>
          <div class="min_item_mid">
            越华鹏诚及战略合作伙伴（威默斯环保）部分资质证书
          </div>
          <div class="min_item_more" @click="routerPages('/about')">
            了解更多<img src="../assets/home/red_right.png" alt="" />
          </div>
        </div>
        <!-- 企业工厂实力 -->
        <div class="about_btm_min_item2">
          <div class="btm_min_item2_wrap">
            <div class="min_item_top">企业工厂实力</div>
            <div class="min_item_mid" style="">
              火花探测器、单项隔爆阀、无烟泄放装置、FB型防火防爆安全柜、T20型多功能废液桶
              T50型阻液泄压废液桶、仓储架、防渗托盘、泄爆片
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资讯中心 -->
    <div class="news_wrap">
      <div class="item_title">
        <div class="item_title_top">资讯中心</div>
        <div class="item_title_btm">INFORMATION</div>
      </div>

      <div class="news_cont">
        <div class="news_cont_left">
          <div class="news_cont_left_text">
            <span>沸石转轮吸附浓缩</span>
            <span>+RTO燃烧装置,实现热量的有效回收利用</span>
          </div>
        </div>
        <div class="news_cont_right">
          <div>
            <div
              class="news_right_item"
              v-for="(item, index) in textList"
              :key="index"
              @mouseover="showImage(index)"
              @click="showImage(index)"
            >
              <div class="news_right_item_text">
                <span>{{ item.text1 }}</span>
                <span class="time">{{ item.text2 }}</span>
              </div>
              <div class="news_right_item_img">
                <img src="../assets/home/right_red_circle.png" alt="" />
              </div>
            </div>
            <div class="news_right_item_more" @click="routerPages('/news')">
              了解更多<img src="../assets/home/red_right.png" alt="" />
            </div>
          </div>
          <div class="news_two" v-if="hoverImageSrc">
            <img :src="hoverImageSrc" alt="图片" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carouselCom from "@/components/CarouselCom.vue";
export default {
  components: {
    carouselCom,
  },
  data() {
    return {
      textList: [
        {
          text1: "【天大越华资讯】第七届淄博化工技术装备展览会邀请函",
          text2: "2023-05-06",
        },
        {
          text1: "诚邀您参加2023第24届中国环博会(上海）新国际博览中心",
          text2: "2023-04-06",
        },
        {
          text1: "欢迎生态环境部环规院领导到越华环保洽谈EOD项目",
          text2: "2023-01-13",
        },
      ], // 文字列表
      imageList: [
        require("../assets/home/news_two.png"),
        require("../assets/home/news_one.png"),
        require("../assets/home/about_max.png"),
      ], // 图片列表
      hoverImageSrc: "", // 鼠标经过时显示的图片的URL
      listData: [
        {
          contTop: "危废终端设备",
          contMid: "一物一码，实时上报，全过程危废溯源",
          imgUrl: require("../assets/home/product_one.png"),
          width: "372px",
          height: "240px",
        },
        {
          contTop: "精细化管理",
          contMid: "将实时为企业自动登记所有台帐",
          imgUrl: require("../assets/home/product_two.png"),
          width: "232px",
          height: "240px",
        },
        {
          contTop: "危废收集数字化管理系统",
          contMid: "对接平台，实现产业上下游融合及联通",
          imgUrl: require("../assets/home/product_three.png"),
          width: "241px",
          height: "240px",
        },
        {
          contTop: "固体废物全过程智慧化管理平台",
          contMid: "“产生→收集→贮存→运输→处置”的全生命周期管理",
          imgUrl: require("../assets/home/product_one.png"),
          width: "372px",
          height: "240px",
        },
      ],
    };
  },
  methods: {
    showImage(index) {
      this.hoverImageSrc = this.imageList[index];
    },
    routerPages(path) {
      this.$router.push(path);
    },
    routerPagess(index) {
      if (index == 0) {
        this.$router.push("/wasteTerminal");
      } else if (index == 1) {
        this.$router.push("/intelligent");
      } else if (index == 2) {
        this.$router.push("/digitalize");
      }
    },
  },
  mounted() {
    // 默认显示第一行文字对应的图片
    if (this.imageList.length > 0) {
      this.hoverImageSrc = this.imageList[0];
    }
    this.$nextTick(() => {
      window.scrollTo(0, 0); // 在页面加载完成后将滚动条位置设置为页面顶部
    });
  },
};
</script>

<style lang="less" scoped>
// PC端
@media screen and (min-width: 769px) {
  .image-container {
    display: inline-block;
    margin-left: 10px;
  }

  .homeView_wrapper {
    cursor: default;

    // 大标题
    .item_title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 98px;

      .item_title_top {
        font-size: 38px;
        font-weight: bold;
        color: #333333;
      }

      .item_title_btm {
        margin-top: 14px;
        font-size: 17px;
        font-weight: 400;
        color: #868686;
      }
    }

    .product_wrap,
    .news_wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #f9fafe;
    }

    .product_wrap {
      padding-bottom: 100px;

      .product_list_top {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 33px;
        padding: 0 396px;
        box-sizing: border-box;

        .top_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          color: #333333;

          img {
            width: 32px;
            height: 32px;
            margin-bottom: 16px;
          }
        }
      }

      .product_line {
        margin: 29px 0 26px 0;
        padding: 0 235px;
        box-sizing: border-box;
        width: 100%;

        .line {
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
        }
      }

      .priduct_2 {
        display: block;
      }

      .priduct_3 {
        display: none;
      }

      .priduct_nobody {
        padding: 0 259px;
        box-sizing: border-box;
        width: 100%;

        .nobody_bg {
          display: flex;
          align-items: center;
          height: 500px;
          width: 100%;
          background-image: url("../assets/home/product_max.png");
          background-size: 100% 100%;
          margin-bottom: 38px;

          .nobody_cont {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 50%;

            .cont_top {
              font-size: 38px;
              font-weight: bold;
              color: #333333;
            }

            .cont_mid {
              margin: 19px 0 37px 0;
              font-size: 17px;
              color: #868686;
            }

            .cont_more {
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              width: 196px;
              height: 40px;
              border: 2px solid #cecece;
              border-radius: 20px;
              font-size: 15px;
              color: #333333;
              cursor: pointer;

              img {
                margin-left: 31px;
                width: 17px;
                height: 17px;
              }
            }
          }
        }
      }
    }

    .about_wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 0 22px;
      box-sizing: border-box;

      .about_text {
        padding: 44px 285px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 17px;
        color: #333333;
      }

      .about_more {
        cursor: pointer;
        margin-bottom: 20px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 33px 0 41px;
        box-sizing: border-box;
        width: 180px;
        height: 40px;
        border: 2px solid #be1420;
        border-radius: 20px;

        img {
          width: 17px;
          height: 17px;
        }
      }

      .about_top_max {
        width: 100%;
        margin-bottom: 21px;

        img {
          width: 100%;
          height: 650px;
        }
      }

      .about_btm_min {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .about_btm_min_item {
          display: flex;
          align-items: center;
          flex-direction: column;
          padding-top: 60px;
          box-sizing: border-box;
          width: 49%;
          height: 479px;
          background-image: url("../assets/home/about_one.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          color: #ffffff;

          .min_item_top {
            font-size: 25px;
            font-weight: bold;
          }

          .min_item_mid {
            font-size: 15px;

            margin: 18px 0 31px 0;
          }

          .min_item_more {
            display: flex;
            cursor: pointer;
            align-items: center;
            font-size: 15px;
            color: #e8430c;

            img {
              margin-left: 17px;
              width: 17px;
              height: 17px;
            }
          }
        }

        .about_btm_min_item2 {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          width: 50%;
          height: 479px;
          background-image: url("../assets/home/about_two.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;

          .btm_min_item2_wrap {
            padding: 233px 0 0 41px;
            box-sizing: border-box;
            height: 363px;
            width: 100%;
            color: #ffffff;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.58) 17%,
              rgba(0, 0, 0, 0) 100%
            );
            cursor: default;

            .min_item_top {
              font-size: 25px;
              font-weight: bold;
            }

            .min_item_mid {
              width: 70%;
              font-size: 15px;
              margin-top: 25px;
            }
          }
        }
      }
    }

    .news_wrap {
      .news_cont {
        margin-top: 30px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        box-sizing: border-box;
        width: 100%;
        padding-bottom: 124px;

        .news_cont_left {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          background-image: url("../assets/home/news_one.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          height: 500px;
          width: 380px;
          cursor: default;

          .news_cont_left_text {
            display: flex;
            flex-direction: column;
            padding-top: 198px;
            padding-left: 22px;
            box-sizing: border-box;
            height: 277px;
            width: 100%;
            font-size: 15px;
            font-weight: bold;
            color: #ffffff;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.5) 10%,
              rgba(0, 0, 0, 0) 100%
            );
          }
        }

        .news_cont_right {
          margin-left: 19px;
          flex: 1;
          display: flex;
          background-color: #fff;
          cursor: pointer;

          .news_right_item {
            // padding: 30px 0 30px 48px;
            padding-left: 45px;
            padding-right: 30px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            width: 411px;
            height: 130px;
            cursor: pointer;

            .news_right_item_text {
              flex: 1;
              display: flex;
              flex-direction: column;
              font-size: 17px;
              color: #333333;
              line-height: 26px;

              .time {
                font-size: 13px;
                color: #bd1723;
              }
            }

            .news_right_item_img {
              margin-left: 60px;

              img {
                width: 14px;
                height: 22px;
              }
            }
          }

          .news_right_item:hover {
            box-shadow: 0px 0px 33px 0px rgba(212, 212, 214, 0.4);
          }

          .news_right_item_more {
            cursor: pointer;
            margin: 0 65px;
            padding-top: 30px;
            border-top: #e5e5e5 1px solid;
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #be1420;

            img {
              margin-left: 35px;
              width: 17px;
              height: 17px;
            }
          }

          .news_two {
            flex: 1;

            img {
              cursor: default;
              width: 100%;
              height: 500px;
            }
          }
        }
      }
    }
  }
}

// 移动端
@media screen and (max-width: 768px) {
  .homeView_wrapper {
    cursor: default;

    // 大标题
    .item_title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .item_title_top {
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        padding-top: 50px;
      }

      .item_title_btm {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 400;
        color: #868686;
      }
    }

    .product_wrap,
    .news_wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #f9fafe;
    }

    .product_wrap {
      padding-bottom: 50px;

      .product_list_top {
        width: 100%;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 20px;
        padding: 0 12px;
        box-sizing: border-box;

        .top_item {
          width: 30%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #333333;
          margin-bottom: 20px;

          img {
            width: 25px;
            height: 25px;
            margin-bottom: 10px;
          }
        }

        .top_item:last-child {
          width: 45%;
        }
      }

      .product_line {
        margin: 10px 0 10px 0;
        padding: 0 12px;
        box-sizing: border-box;
        width: 100%;

        .line {
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
        }
      }

      .priduct_2 {
        display: none;
      }

      .priduct_3 {
        display: block;
        width: 100%;

        .carouselCom_cont_item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          background-color: #fff;
          margin-bottom: 10px;
          padding: 12px;
          box-sizing: border-box;

          .carouselCom_cont_top {
            text-align: center;
            font-size: 27px;
            font-weight: bold;
            color: #333333;
          }

          .carouselCom_cont_mid {
            text-align: center;
            font-size: 15px;
            color: #868686;
            margin: 10px 0 20px 0;
          }

          .carouselCom_cont_more {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #333333;
            margin-bottom: 10px;
            cursor: pointer;

            img {
              width: 15px;
              height: 15px;
              margin-left: 23px;
            }
          }

          .carouselCom_cont_img {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 70%;
            }
          }
        }
      }

      .priduct_nobody {
        padding: 0 16px;
        box-sizing: border-box;
        width: 100%;

        .nobody_bg {
          display: flex;
          align-items: center;
          height: 300px;
          width: 100%;
          background-image: url("../assets/home/product_max.png");
          background-size: 100% 100%;
          margin-bottom: 18px;

          .nobody_cont {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 50%;

            .cont_top {
              font-size: 28px;
              font-weight: bold;
              color: #333333;
            }

            .cont_mid {
              margin: 19px 0 37px 0;
              font-size: 17px;
              color: #868686;
            }

            .cont_more {
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              width: 196px;
              height: 40px;
              border: 2px solid #cecece;
              border-radius: 20px;
              font-size: 15px;
              color: #333333;
              cursor: pointer;

              img {
                margin-left: 31px;
                width: 17px;
                height: 17px;
              }
            }
          }
        }
      }
    }

    .about_wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 20px 12px;
      box-sizing: border-box;

      .about_text {
        padding: 24px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 17px;
        color: #333333;
      }

      .about_more {
        cursor: pointer;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 33px 0 41px;
        box-sizing: border-box;
        width: 180px;
        height: 40px;
        border: 2px solid #be1420;
        border-radius: 20px;

        img {
          width: 17px;
          height: 17px;
        }
      }

      .about_top_max {
        width: 100%;
        margin-bottom: 21px;

        img {
          width: 100%;
          height: 350px;
        }
      }

      .about_btm_min {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .about_btm_min_item {
          display: flex;
          align-items: center;
          flex-direction: column;
          padding-top: 10px;
          box-sizing: border-box;
          width: 49%;
          height: 170px;
          background-image: url("../assets/home/about_one.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          color: #ffffff;

          .min_item_top {
            font-size: 18px;
            font-weight: bold;
          }

          .min_item_mid {
            font-size: 12px;
            margin: 5px 0;
          }

          .min_item_more {
            display: flex;
            cursor: pointer;
            align-items: center;
            font-size: 12px;
            color: #e8430c;

            img {
              margin-left: 17px;
              width: 10px;
              height: 10px;
            }
          }
        }

        .about_btm_min_item2 {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          width: 50%;
          height: 170px;
          background-image: url("../assets/home/about_two.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;

          .btm_min_item2_wrap {
            padding: 70px 0 0 10px;
            box-sizing: border-box;
            height: 170px;
            width: 100%;
            color: #ffffff;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.58) 17%,
              rgba(0, 0, 0, 0) 100%
            );
            cursor: pointer;

            .min_item_top {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 5px;
            }

            .min_item_mid {
              width: 70%;
              font-size: 12px;
            }
          }
        }
      }
    }

    .news_wrap {
      padding-top: 20px;

      .news_cont {
        margin-top: 30px;
        padding: 0 12px;
        box-sizing: border-box;
        width: 100%;
        cursor: pointer;
        padding-bottom: 30px;

        .news_cont_left {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          background-image: url("../assets/home/news_one.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          height: 700px;
          width: 100%;

          .news_cont_left_text {
            display: flex;
            flex-direction: column;
            padding-top: 198px;
            padding-left: 22px;
            box-sizing: border-box;
            height: 277px;
            width: 100%;
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.5) 10%,
              rgba(0, 0, 0, 0) 100%
            );
          }
        }

        .news_cont_right {
          background-color: #fff;

          .news_right_item {
            display: flex;
            justify-content: space-between;
            padding: 40px 30px 20px 30px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            .news_right_item_text {
              flex: 1;
              display: flex;
              flex-direction: column;
              font-size: 17px;
              color: #333333;
              line-height: 26px;

              .time {
                font-size: 13px;
                color: #bd1723;
              }
            }

            .news_right_item_img {
              margin-left: 60px;

              img {
                width: 14px;
                height: 22px;
              }
            }
          }

          .news_right_item_more {
            width: 100%;
            padding: 15px 0;
            border-top: #e5e5e5 1px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #be1420;

            img {
              margin-left: 35px;
              width: 10px;
              height: 10px;
            }
          }

          .news_two {
            // position: fixed;
            // top: 30%;
            // left: 10%;

            img {
              width: 100%;
              height: 400px;
            }
          }
        }
      }
    }
  }
}
</style>
